module.exports = __webpack_public_path__ + "03_long_grey.7b16e8da.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/papa/layer5/03_long_grey.png
// module id = xrdA
// module chunks = 0